export default {
  External: {
    ProviderConnectToOtherMisaId: 'Email/số điện thoại đã liên kết với tài khoản MisaID khác',
    TitleEnterAccount: 'Bổ sung thông tin',
    SubtitleEnterAccount: 'Vui lòng nhập email/số điện thoại'
  }
}
